import { BaseError } from './base';

export function PopupError(message, debug, code, kinveyRequestId) {
  this.name = 'PopupError';
  this.message = message || 'Unable to open a popup on this platform.';
  this.debug = debug || undefined;
  this.code = code || undefined;
  this.kinveyRequestId = kinveyRequestId || undefined;
  this.stack = (new Error()).stack;
}
PopupError.prototype = Object.create(BaseError.prototype);
PopupError.prototype.constructor = PopupError;



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/errors/popup.js